var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var alertListState = {
    data: null,
    error: null,
    loading: false
};
var alertReducer = function (state, action) {
    if (state === void 0) { state = alertListState; }
    switch (action.type) {
        case Types.GET_ALERT_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_ALERT_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_ALERT_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_ALERT_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var AlertReducer = {
    alertData: alertReducer
};
export var alertData = function (state) { return (state.alertData.data ? state.alertData.data : null); };
export var alertError = function (state) { return state.alertData.error; };
export var isLoadAlert = function (state) { return state.alertData.loading; };
export default AlertReducer;
